import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Forecasting/ForecastForm';

const ForecastForm = () => ((orgContainer(InnerComponent)));

export default ForecastForm;
